module.exports = __webpack_public_path__ + "img/i.56903f06.jpg";